import { tourKeys } from '../@utils/tourKeys'

export default function getPackagesSteps() {
    const k = tourKeys('packages')

    return [
        {
            target: '.sticky-header',
            contentKey: k.welcome,
            placement: 'bottom',
            disableBeacon: true,
            disableScrolling: true,
        },
        {
            target: '.select-report-execution-header',
            contentKey: k.reportExecution,
            placement: 'bottom',
            disableScrolling: true,
        },
        {
            target: '.filter-containers',
            contentKey: k.filters,
            placement: 'bottom',
            disableScrolling: true,
        },
        {
            target: '.competition-kpis',
            contentKey: k.kpiCards,
            placement: 'bottom',
            data: {
                beforeNext: () => document.querySelector('.title-tables-packages')?.scrollIntoView({ behavior: 'smooth', block: 'start' }),
                delay: 800,
            },
        },
        {
            target: '.title-tables-packages',
            contentKey: k.tablesSection,
            placement: 'top',
            data: {
                beforeNext: () => document.querySelector('.switch-table-prices')?.scrollIntoView({ behavior: 'smooth', block: 'center' }),
                delay: 800,
            },
        },
        {
            target: '.switch-table-prices',
            contentKey: k.tabSelector,
            placement: 'top',
        },
        {
            target: '.table-daily-price',
            contentKey: k.priceTable,
            placement: 'top',
            data: {
                beforeNext: () => document.querySelector('.chart-price-compare')?.scrollIntoView({ behavior: 'smooth', block: 'start' }),
                delay: 800,
            },
        },
        {
            target: '.chart-price-compare',
            contentKey: k.evolutionChart,
            placement: 'top',
        },
    ]
}
